const GENERIC_TAX_PROFILE = 'XAXX010101000';
const FOREIGN_GENERIC_TAX_PROFILE = 'XEXX010101000';
const GENERIC_TAX_PROFILES = [GENERIC_TAX_PROFILE, FOREIGN_GENERIC_TAX_PROFILE];
const LINK_RFC_VALIDATION = 'https://www.sat.gob.mx/aplicacion/operacion/79615/valida-en-linea-rfc%C2%B4s-uno-a-uno-o-de-manera-masiva-hasta-5-mil-registros';
const TERMS_AND_CONDITIONS = 'https://porcobrar-help.zendesk.com/hc/es-419/articles/26952891135259';

export { GENERIC_TAX_PROFILE, FOREIGN_GENERIC_TAX_PROFILE, GENERIC_TAX_PROFILES, LINK_RFC_VALIDATION, TERMS_AND_CONDITIONS };



// WEBPACK FOOTER //
// ./src/constants/customer.js